import React from 'react';

import LinearProgress, { LinearProgressProps } from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/styles';

type Props = LinearProgressProps & {
  primaryCount: number;
  secondaryCount: number;
};

export const DoubleProgressBar = withStyles((theme) => ({
  root: {
    height: '10px',
  },
  barColorPrimary: {
    backgroundColor: theme.palette.primary[300],
  },
  bar2Buffer: {
    backgroundColor: theme.palette.secondary[300],
  },
  dashed: {
    animation: 'none',
    backgroundColor: theme.palette.primary[100],
    backgroundImage: 'inherit',
  },
}))((props: Props) => {
  const { primaryCount, secondaryCount, ...linearProgressProps } = props;

  return (
    <LinearProgress value={primaryCount} valueBuffer={secondaryCount} {...linearProgressProps} />
  );
});
